export interface Metric {
  id: string
  attendance_count: number
  tma_total_seconds: number
  tma_sample_count: number
  tme_total_seconds: number
  tme_sample_count: number
  queues: { id: string; display_name: string; kind: 'ATTENDANCE' | 'NAVIGATION'; timing_enabled: boolean }
  operators: { id: string; external_name: string; display_name: string | null } | null
}

export function summarize(metrics: Metric[]) {
  let volume = 0, navigation = 0, tmaTotal = 0, tmaSamples = 0, tmeTotal = 0, tmeSamples = 0
  for (const metric of metrics) {
    volume += metric.attendance_count
    if (metric.queues.kind === 'NAVIGATION') navigation += metric.attendance_count
    if (metric.queues.kind === 'NAVIGATION' || !metric.queues.timing_enabled) continue
    tmaTotal += metric.tma_total_seconds
    tmaSamples += metric.tma_sample_count
    tmeTotal += metric.tme_total_seconds
    tmeSamples += metric.tme_sample_count
  }
  return { volume, navigation, tmaSamples, tmeSamples,
    tma: tmaSamples ? tmaTotal / tmaSamples : null,
    tme: tmeSamples ? tmeTotal / tmeSamples : null }
}

export function duration(seconds: number | null) {
  if (seconds === null) return '—'
  const value = Math.round(seconds)
  return [Math.floor(value / 3600), Math.floor(value / 60) % 60, value % 60]
    .map(part => String(part).padStart(2, '0')).join(':')
}
